var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5125_30030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#F1DC50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.332C20 26.2474 20 30.6918 20 31.6654C20 33.1257 19.1285 34.9987 16.6667 34.9987C12.691 34.9987 12.5 31.6654 12.5 31.6654M34.6499 22.5254C33.6498 20.8409 32.324 19.9987 30.6726 19.9987C28.0939 19.9987 26.6667 21.6654 26.6667 23.332C26.6667 24.9987 27.5 26.6654 30.8474 27.4987C32.9774 28.029 35 29.1654 35 31.6654C35 34.1654 32.8076 34.9987 30.8333 34.9987C28.3103 34.9987 26.6436 33.8876 25.8333 31.6654",
    stroke: "#333333",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5125_30030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.46f6f485780ab35b9dec4ae95a5ce085.svg";
export { ForwardRef as ReactComponent };